import { renderToolbarGroup_unstable } from '@fluentui/react-toolbar';

/**
 * Renders the final JSX of the ToolbarGroup component, given the state.
 */
export const renderToolbarGroup = renderToolbarGroup_unstable;
